import { ORDER_PAGES, ORDERS_PAGES } from "./pages"

const ORDER_PATHS: string[] = Object.keys(ORDER_PAGES)
const ORDERS_PATHS: string[] = Object.keys(ORDERS_PAGES)

export const routing = (route: string, location: string, orderId?: string, back: boolean = false, page?: string) => {
  let path = route
  const endOfPath = location.split("/").pop()

  const addOrderRoute = orderId && !back
  if (addOrderRoute) {
    if (!path.endsWith("/")) path += "/"

    path += `${orderId}`
  }

  const paths = [...(orderId ? ORDER_PATHS : ORDERS_PATHS)]
  if (!back && typeof page !== "string" && endOfPath && paths.includes(endOfPath)) {
    if (path.endsWith("/")) path = path.slice(0, -1)
    return path + "/" + endOfPath
  }

  if (page) {
    if (path.endsWith("/")) path = path.slice(0, -1)

    return path + "/" + page
  }

  return path
}
